export default "__VITE_ASSET__CD75l_kt__"